<app-toolbar-popover class="button-list-one-item" [displayMode]="displayMode.ExpandCollapse"
    [collapsedButton]="collapsedButtonItem" [expandedButtons]="expandedButtonItems">
</app-toolbar-popover>